module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'op--modal-container': true, hide: !_vm.show
    },
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "op--modal"
  }, [_c('div', {
    staticClass: "op--modal-content"
  }, [_c('div', {
    staticClass: "guest-input small-margin-v-s",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.whoBooking')))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addGuest($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "field-text",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('rsvpEdit.firstName')
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "field-text",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('rsvpEdit.lastName')
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "field-text",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('rsvpEdit.phoneNumber')
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'error-message': true, hide: !_vm.error.show
    }
  }, [_vm._v(_vm._s(_vm.error.message))]), _vm._v(" "), _c('button', {
    staticClass: "op-btn btn-block btn-success btn-lg margin-t-s"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.save')))]), _vm._v(" "), _c('a', {
    staticClass: "remove-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.clearGuest
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.bookForMyself')))])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-76d1e3fd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76d1e3fd","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RsvpEdit/GuestInformation.vue
// module id = 2115
// module chunks = 0